export const portfoliodata = [
  {
    id: 1,
    name: "Quantum Hardware",
    content:
      "Our quantum hardware portfolio includes advanced systems such as quantum memory platforms, quantum biosensors, and precision laser technologies like ECDL—designed to enable real-world quantum experiments, sensing, communication, and scalable infrastructure for academia and industry.",
  },
  {
    id: 2,
    name: "Quantum-AI Integration",
    content:
      "We combine quantum computing with artificial intelligence to build hybrid solutions that solve complex computational problems, optimize algorithms, and enable intelligent decision-making—helping organizations transition toward next-generation computing systems.",
  },
  {
    id: 3,
    name: "Quantum Software",
    content:
      "Our quantum software portfolio includes platforms like Q-Cluster and QNTSim, along with our Post-Quantum Cryptography (PQC) product suite—offering simulation of high-fidelity quantum algorithms, quantum communication protocols, and quantum-resilient security solutions for secure communication and enterprise applications.",
  },
];

export const aboutdata = [
  {
    id: 1,
    name: "Vision",
    content:
      "At the intersection of quantum technologies and artificial intelligence, we design and deliver scalable products, solutions, and infrastructure that enable organizations to adopt and leverage quantum capabilities. Through strong R&D and product innovation, we transform complex scientific advancements into practical, deployable systems.",
  },
  {
    id: 2,
    name: "Mission",
    content:
      "To accelerate the adoption of quantum and AI technologies by developing high-impact products, advancing research, and delivering scalable solutions that enable organizations to harness the full potential of next-generation technologies.",
  },
  {
    id: 3,
    name: "Values",
    content:
      "Innovation, deep-tech excellence, product-driven research, integrity, collaboration, and global impact guiding our commitment to building scalable quantum technologies and delivering real-world value.",
  },
];

export const homepagebox = [
  {
    id: 1,
    title: "Products",
    description:
      "We build advanced quantum and AI products that bridge research and real-world use. Our portfolio includes quantum communications systems, biosensors, laser platforms, and AI-driven quantum software—designed for academia, industry, and government to easily adopt and scale next-generation technologies. Designed for scalability. Built for real-world impact. ",
    link: "/Products/Hardware",
  },
  {
    id: 2,
    title: "Services",
    description:
      "We help organizations adopt quantum and AI through end-to-end support, including system integration, solution development, deployment, and commercialization ensuring a smooth transition from innovation to practical implementation. ",
    link: "/Services",
  },
];

export const numberdata = [
  {
    number: "5+",
    name: "Research Partners",
  },
  {
    number: "4+",
    name: "Global Research Labs",
  },
  {
    number: "45+",
    name: "Quantum Scientists",
  },
  {
    number: "4+",
    name: "Countries World Wide",
  },
];

export const data = [
  {
    id: 1,
    logo: "QuantumSimulations",
    heading: "Universal Quantum Simulations",
    data: "We are creating quantum simulation solutions for various physics and chemistry applications. Our state-of-the-art solutions are designed to revolutionize the fields of fundamental science and beyond. ",

    Content: [
      {
        head: "About Us",
        content: [
          "Welcome to Universal Quantum Simulations, a project dedicated to developing quantum simulation solutions for wide range of applications. Our team of expert researchers and developers are dedicated to push the limits of what is possible with quantum simulations.",
        ],
      },
      {
        head: "Our Mission",
        content: [
          "Our mission at Universal Quantum Simulations is to leverage the power of quantum simulations to drive innovation across a range of industries. Our focus is on creating cutting-edge technology that enables faster and more precise simulations of complex systems, whether we're studying molecular interactions, enhancing battery performance, or simulating materials. Our team is developing a quantum-assisted approach towards accelerating the drug discovery process, which has the potential to revolutionise the pharmaceutical sector by enabling rapid development of life-saving drugs.",
        ],
      },
      {
        head: "Our Team",
        content: [
          "Our team consists of experienced researchers and developers with expertise in quantum computing, physics, material science and software engineering. We are passionate about advancing the field of quantum computing while employing our technology to address issues in the real world.",
        ],
      },
      {
        head: "Our Solutions",
        content: [
          "​Introducing the world's first software-based quantum random number generator - a tool that is for the first time a ‘no-black box’ solution for generating quantum randomness but with transparency and flexibility of use. Our technique exploits quantum mechanics to produce high-quality random bits. This revolutionary technology is based on the digital quantum simulation of a 'Quantum Beam Splitter'. It's incredibly accessible - no need to worry anymore about dedicated hardware black boxes. Our solution is compatible with any universal gate-based quantum computer, providing ultimate flexibility. And it comes with multi-layer security to ensure the confidentiality of your random bits. We bring you the ultimate solution for random number generation.",
        ],
      },
      {
        head: "Applications:",
        content: [
          "Quantum simulation solutions that we are working on, can be applied to a wide range of industries, including materials science, chemistry, biology, finance, and energy. Our solutions can help optimize material properties, predict reaction rates, design new catalysts, study molecular interactions, simulate market behaviour, and optimize energy production and storage, among other things.",
        ],
      },
      {
        head: "Contact Us",
        content: [
          "If you are interested in learning more about our quantum simulation solutions or would like to discuss how we can help solve your complex problems, please contact us at Info@qulabs.ai We look forward to hearing from you!",
        ],
      },
    ],
    link: [
      {
        head: "",
        address: "",
        content: "for more details visit ",
      },
    ],
  },
  {
    id: 2,
    logo: "QuantumEducation",
    heading: "Quantum Education",
    data: "QuAcademy, the centre of excellence for Qulabs is focused on Quantum and AI training.Quantum graduate and training programs are still not widely available. Qulabs has collaborated with major institutions in India to close the gap in Quantum Education. ",
    Content: [
      {
        head: "Overview",
        content: [
          "The Applied Quantum Computing Training course at QuLabs is designed to provide students with a comprehensive understanding of the practical applications of quantum computing. By taking this course, students develop foundational skills in quantum mechanics, quantum information and computation, and quantum algorithms and protocols.",
        ],
      },
      {
        head: "Prerequisite",
        content: [
          "Basic linear algebra",
          "Sets and functions",
          "Complex numbers",
          "Basic programming background",
        ],
      },
      {
        head: "Key Benefits",
        content: [
          "Interactive classes by industry experts",
          "Real-time Projects",
          "Free access to LMS(Learning Management System)",
          "Industry Recognised Certification",
          "Job Assistance",
        ],
      },
      {
        head: "Program Outcomes",
        content: [
          "Understanding of Quantum Computing concepts",
          "Understanding of basic quantum logical operations and algorithms",
          "Framework of quantum error-correcting codes",
          "Knowledge about the practical use of quantum algorithms",
          "Principles of quantum information and quantum communication",
          "Understand quantum teleportation and its limits",
        ],
      },
    ],
    link: [
      {
        head: "QuAcademy",
        address: "https://www.quacademy.com/",
        content: "for more details visit: ",
      },
    ],
  },

  {
    id: 3,
    logo: "QuantumMemory",
    heading: "Quantum Memory",
    data: "The Quantum Optics Lab of Qulabs is focused on developing the hardware building blocks of “Quantum Internet” such as quantum memory (QM), single photon sources (SPS), entangled photon sources (EPS), quantum random number generator (QRNG), atomic clocks (AC), etc.",
    Content: [
      {
        head: "",
        content: [
          "Unlocking the potential of long-distance entanglement in quantum communications requires overcoming challenges in quantum repeaters and entanglement swapping. At Qulabs, we address this crucial aspect with our innovative room temperature Rb-based Quantum Memory. Operating on the principles of electromagnetically induced transparency, our quantum memory system, with a portable 2U-19 inch rack design, efficiently stores and retrieves polarization qubits at a wavelength of 795 nm. This breakthrough technology enables high-fidelity retrieval, making it a vital component for quantum repeaters, facilitating entanglement swapping operations in quantum communication systems.",
        ],
      },
    ],
    link: [
      {
        head: "",
        address: "",
        content: "for more details visit ",
      },
    ],
  },

  {
    id: 4,
    logo: "QuantumCommunication",
    heading: "Quantum Communication",
    data: "Quantum Communication holds the promise of unconditional secure communication which is not hackable. This motivates us to develop a prototype 5-6 node quantum network in the lab and test for it to be scaled in the future for real deployment. ",
    Content: [
      {
        head: "Quantum Communication: Secure Protocols and Quantum Network",
        content: [
          "We are developing secure quantum communication protocols to serve wide range of applications and help our users migrate swiftly from vulnerable classical practices to secure quantum assisted communications. We are also laying the foundations of Quantum Network which will serve as the building block for performing quantum secured communications.",
        ],
      },
      {
        head: "At A Glance:",
        content: [
          "We design quantum secured protocols assisting secure direct communication QSDC and Quantum secret sharing. Our team of experts have also designed a Quantum Network Simulator which provides the first step to test these protocols in a real test scenario.",
        ],
      },
      {
        head: "Our focus areas: Protocols",
        content: [
          "We design quantum communication protocols assisted by entanglement distribution and teleportation. Our range of protocols are designed to assist Quantum Dialogue, Quantum Conference, Quantum multi-party communication, MDI and DI protocols and many more. These protocols can be used as a migration from today’s vulnerable classical communication protocols to quantum secured communication.",
        ],
      },
      {
        head: "Our focus areas: Networks",
        content: [
          "Towards our mission to lay the foundations of quantum networks, we develop protocols across almost all the layers of quantum computer networks. We develop quantum network routing algorithms and algorithms to facilitate entanglement distribution across a wide topology. Our quantum network simulator serves as the first virtual test bed in testing the performance of this protocols and its scalability. We are focused towards developing a commercially viable and scalable quantum networking infrastructure.",
        ],
      },
    ],
    link: [
      {
        head: "",
        address: "",
        content: "for more details visit ",
      },
    ],
  },

  {
    id: 5,
    logo: "QuantumAI",
    heading: "Quantum Artificial Intelligence",
    data: "We are building machine learning capabilities that are superior to traditional classical algorithm and solves computationally intensive problems. ",
    Content: [
      {
        head: "At A Glance:",
        content: [
          "Quantum machine learning is an exciting and rapidly growing field at the intersection of quantum computing and machine learning. With the advent of the Noisy Intermediate-Scale Quantum (NISQ) era, we are witnessing a major shift in computing power and the potential for new breakthroughs in areas that were once considered intractable for classical computers.",
        ],
      },
      {
        head: " ",
        content: [
          "In particular, quantum machine learning is expected to have a significant impact on two broad areas: non-convex optimization and combinatorial optimization. These are both problems that are notoriously difficult for classical computers to solve due to the exponential growth in computational complexity as the problem size increases.",
        ],
      },
      {
        head: " ",
        content: [
          "By leveraging the powerful laws of quantum mechanics, such as superposition and entanglement, quantum machine learning has the potential to solve these problems significantly faster than classical algorithms. This is especially important as data sets continue to grow in size and complexity, making it increasingly difficult for classical computers to handle the computations involved.",
        ],
      },
      {
        head: " ",
        content: [
          "While quantum machine learning is still a relatively new field, its potential impact on our future cannot be overstated. As we continue to explore the capabilities of NISQ-era quantum computers and beyond, we can expect to see even more exciting developments in this area and potentially solve some of the most complex problems facing our world today.",
        ],
      },
      {
        head: "What We Do:",
        content: [
          "At Qulabs we are building Quantum tools, APIs, AI tools, APIs for various applications. Our solutions provide easy to use interface for leveraging Classical-Quantum algorithms. This Classical-Quantum hybrid approach is required in advance use cases to obtain speed up in optimization workloads in various applications involving Combinatorial Optimization Problems.",
        ],
      },
      {
        head: "Quantum-Finance",
        content: [
          "is a very promising application of Quantum Computing. Among the huge variety of problems currently, Quantum Computing is good for portfolio optimization, stock-option pricing, and fraud detection. Many problems in finance can be expressed as optimization problems. These are tasks that are particularly hard for classical computers, but find a natural formulation using quantum optimization methods. In recent years, this field has experienced tremendous growth, partly due to the commercial availability of quantum annealers and quantum computers.",
        ],
      },
      {
        head: "Our Solutions Are Quantum Agnostic:",
        content: [
          "As different problems are tailored for different platforms, we are building our algorithms to run on all possible quantum hardware platforms:",
        ],
      },
      {
        head: "Our Solutions Are Quantum Inspired:",
        content: [
          "Suitable for the current NISQ era, we are developing new algorithms that can be applied now using different strategies:",
        ],
      },
    ],
    link: [
      {
        head: "Quantum",
        address: "https://thequantum.ai/",
        content: "for more details visit: ",
      },
    ],
  },
  {
    id: 6,
    logo: "Post-Quantum Cryptography",
    heading: "Post-Quantum Cryptography",
    data: "We are dedicated to developing and implementing cutting-edge post-quantum cryptographic solutions. Our focus is on creating post-quantum cryptographic protocols and their applications that are both secure and efficient.",
    Content: [
      {
        head: "",
        content: [
          "Today the traditional cryptographic protocols are at alarming threat with the exponential progress in Quantum computing powerand the mere security based on the traditional hard mathematical problems, which does not hold strong in front of Quantum computers. Hence, there is an immediate requirement of migrating into algorithms/protocols which are quantum safe as well. We are developin software products using post-quantum cryptographic algorithms that are quantum-secure and resistant to classical attacks.  ",
        ],
      },
    ],
    link: [
      {
        head: "",
        address: "",
        content: "for more details visit ",
      },
    ],
  },
];
